var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { overflow: "auto" } }, [
    _c("div", { staticClass: "nav-bar-container" }, [
      _c("div", { staticClass: "clearfix nav-bar" }, [
        _c("div", { staticClass: "welcome" }, [
          _c("span", { staticClass: "summary-hello" }, [
            _vm._v(_vm._s(_vm.$t("hello"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "summary-name" }, [
            _vm._v(_vm._s(_vm.renderedName)),
          ]),
          _vm._v(" "),
          _vm.showTendersTable || _vm.showProjectsTable
            ? _c("span", { staticClass: "summary-hello" }, [
                _vm._v(", " + _vm._s(_vm.$t("hint.youHave")) + ":"),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "summary-items" }, [
          _vm.showTendersTable
            ? _c(
                "div",
                {
                  staticClass: "summary-item",
                  on: {
                    click: function ($event) {
                      return _vm.scrollMeTo("tendersTable")
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "summary-badge summary-badge__dark" },
                    [_vm._v(_vm._s(_vm.tenders.length))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-item__title" }, [
                    _vm._v(_vm._s(_vm.$t("dashboard.tendersInProgress"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showProjectsTable
            ? _c(
                "div",
                {
                  staticClass: "summary-item",
                  on: {
                    click: function ($event) {
                      return _vm.scrollMeTo("projectsTable")
                    },
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "summary-badge summary-badge__normal" },
                    [_vm._v(_vm._s(_vm.projectNumber))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-item__title" }, [
                    _vm._v(_vm._s(_vm.$t("dashboard.activeProjects"))),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.showTendersTable
      ? _c(
          "div",
          { attrs: { id: "tendersTable" } },
          [
            _c("TendersTable", {
              key: _vm.componentKey,
              attrs: { model: _vm.tenders },
              on: {
                "update:model": function ($event) {
                  _vm.tenders = $event
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showProjectsTable
      ? _c(
          "div",
          { attrs: { id: "projectsTable" } },
          [
            _c("ProjectsTable", {
              key: _vm.componentKey,
              attrs: { id: "projectTable", items: _vm.projects },
              on: {
                "update:items": function ($event) {
                  _vm.projects = $event
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }